import { Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import RightSidebarPaper from '../../../../components/ui-component/form-component/right-side-bar/RightSidebarPaper';
import { useApplication } from '../../../../context/ApplicationContext';
import { DisplayDate, DisplayDateTime } from '../../../../utils/formats';
import { enumT } from '../../../../utils/helper';

// import Schemas
import VerwendungsNachweisSchema from '../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const VN_P = VerwendungsNachweisSchema.attributes;

const VerwendungsnachweisRichtSidebar: FC<{}> = () => {
	const { application } = useApplication();

	return (
		<>
			<RightSidebarPaper>
				<span>
					<Typography>Online-Formular:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{enumT(get(application, VN_P.Allgemein_Nachweistyp.path, ''))}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Status:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{enumT(get(application, VN_P.Status_Status.path))}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Antragstitel:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{enumT(get(application, VN_P.Antrag.schema.attributes.Zusammenfassung_Ueberblick_Titel.path))}
					</Typography>
				</span>
				<span>
					<Typography>Laufzeit von:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDate(get(application, VN_P.Antrag.schema.attributes.Zusammenfassung_Ueberblick_Laufzeit_Von.path))}
					</Typography>
				</span>
				<span>
					<Typography>Laufzeit bis:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDate(get(application, VN_P.Antrag.schema.attributes.Zusammenfassung_Ueberblick_Laufzeit_Bis.path))}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Erstellt am:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDateTime(get(application, 'attributes.createdAt'))}
					</Typography>
				</span>

				<span>
					<Typography variant='body1'>Zuletzt geändert am:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDateTime(get(application, VN_P.Allgemein_Geaendert_Durch_Antragsteller.path, ''))}
					</Typography>
				</span>
			</RightSidebarPaper>
		</>
	);
};
export default VerwendungsnachweisRichtSidebar;
